import { TableNames } from '~/constants';
import logging from '~/stores/providers/logging';
import { DBSchema, IDBPDatabase, openDB } from 'idb';
import { curry } from 'ramda';

interface DoorayDB extends DBSchema {
  SETTINGS: {
    key: string;
    value: string;
  };
  DRAFT_LOGS: {
    key: string;
    value: string;
  };
  FAVORITE_FOLDER_OPENED: {
    key: string;
    value: string;
  };
  SIDE_APP_READ_URL: {
    key: string;
    value: { [itemId: string]: boolean };
  };
}

const DB_NAME = 'DoorayMessenger';
const idb = (() => {
  let db: Promise<IDBPDatabase<DoorayDB>> = null;

  return {
    db,
    initialize: () => {
      db = openDB<DoorayDB>(DB_NAME, 1, {
        upgrade(db, oldVersion) {
          logging.log('IDB 생성');

          if (oldVersion < 1) {
            db.createObjectStore(TableNames.Settings);
            db.createObjectStore(TableNames.DraftLogs);
            db.createObjectStore(TableNames.FavoriteFolderOpened);
          }

          db.createObjectStore(TableNames.SideAppReadURL);
        },
        blocked() {
          logging.log('IDB blocked');
        },
        blocking() {
          logging.log('IDB blocking');
        },
        terminated() {
          logging.log('IDB terminated');
        },
      });
    },
    get: curry(async (tableName: TableNames, key: string) => {
      return (await db).get(tableName, key);
    }),
    getAll: curry(async (tableName: TableNames) => {
      return (await db).getAll(tableName);
    }),
    put: curry(async (tableName: TableNames, key: string, value: string) => {
      return (await db).put(tableName, value, key);
    }),
    add: curry(async (tableName: TableNames, key: string, value: string) => {
      return (await db).add(tableName, value, key);
    }),
    delete: curry(async (tableName: TableNames, key: string) => {
      return (await db).delete(tableName, key);
    }),
    clear: async (tableName: TableNames) => {
      return (await db).clear(tableName);
    },
    keys: async (tableName: TableNames) => {
      return (await db).getAllKeys(tableName);
    },
  };
})();

export default idb;
